const IMPERSONATE_PATH = '/impersonate';
const TOKEN_PARAM = 'token';

let handoffToken: string | null = null;

/**
 * Il backoffice apre `/impersonate?token=…&tenant=…`: il token di passaggio
 * è una credenziale (monouso, 5 minuti). Da chiamare al boot, PRIMA di Sentry,
 * Clarity e del router: lo tiene in memoria e lo toglie dall'indirizzo con
 * `replaceState`, così non resta in cronologia, nelle registrazioni di
 * sessione né nel `Referer` delle richieste successive.
 */
export function captureImpersonationHandoffToken(
  win: Pick<Window, 'location' | 'history'> = window
): void {
  const url = new URL(win.location.href);
  if (url.pathname !== IMPERSONATE_PATH) return;
  const token = url.searchParams.get(TOKEN_PARAM);
  if (!token) return;
  handoffToken = token;
  url.searchParams.delete(TOKEN_PARAM);
  win.history.replaceState(win.history.state, '', url.toString());
}

/** Il token catturato al boot, o `null` se la pagina non ne aveva uno. */
export function readImpersonationHandoffToken(): string | null {
  return handoffToken;
}

export function resetImpersonationHandoffTokenForTest(): void {
  handoffToken = null;
}
